import { SvgIcon } from "@mui/material";
import React from "react";

const ControlPanelIcon = ({ fill }) => {
  return (
    <SvgIcon>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Panel border ring */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 1.25C1.58579 1.25 1.25 1.58579 1.25 2V18C1.25 18.4142 1.58579 18.75 2 18.75H18C18.4142 18.75 18.75 18.4142 18.75 18V2C18.75 1.58579 18.4142 1.25 18 1.25H2ZM2.75 2.75V17.25H17.25V2.75H2.75Z"
          fill={fill}
        />

        {/* Left semicircle gauge — outer arc ring */}
        <path
          d="M3 9.5 A2.5 2.5 0 0 0 8 9.5 L7 9.5 A1.5 1.5 0 0 1 4 9.5 Z"
          fill={fill}
        />
        {/* Left gauge needle (rotated rect) */}
        <rect
          x="5.1"
          y="7.3"
          width="0.8"
          height="2.3"
          rx="0.4"
          fill={fill}
          transform="rotate(25, 5.5, 9.5)"
        />
        {/* Left gauge center hub */}
        <circle cx="5.5" cy="9.5" r="0.75" fill={fill} />
        {/* Left gauge base line */}
        <rect x="3" y="9.5" width="5" height="0.6" rx="0.3" fill={fill} />

        {/* Right semicircle gauge — outer arc ring */}
        <path
          d="M12 9.5 A2.5 2.5 0 0 0 17 9.5 L16 9.5 A1.5 1.5 0 0 1 13 9.5 Z"
          fill={fill}
        />
        {/* Right gauge needle (pointing nearly straight up) */}
        <rect
          x="14.1"
          y="7.3"
          width="0.8"
          height="2.3"
          rx="0.4"
          fill={fill}
          transform="rotate(-5, 14.5, 9.5)"
        />
        {/* Right gauge center hub */}
        <circle cx="14.5" cy="9.5" r="0.75" fill={fill} />
        {/* Right gauge base line */}
        <rect x="12" y="9.5" width="5" height="0.6" rx="0.3" fill={fill} />

        {/* Horizontal divider */}
        <rect x="2.75" y="11" width="14.5" height="0.5" rx="0.25" fill={fill} />

        {/* Slider 1 — track */}
        <rect x="3" y="12.75" width="6.5" height="0.7" rx="0.35" fill={fill} />
        {/* Slider 1 — thumb (positioned at 65%) */}
        <circle cx="7.2" cy="13.1" r="1.05" fill={fill} />

        {/* Slider 2 — track */}
        <rect
          x="10.5"
          y="12.75"
          width="6.5"
          height="0.7"
          rx="0.35"
          fill={fill}
        />
        {/* Slider 2 — thumb (positioned at 35%) */}
        <circle cx="12.8" cy="13.1" r="1.05" fill={fill} />

        {/* Bottom LED indicator row */}
        <circle cx="4.5" cy="16" r="0.75" fill={fill} />
        <circle cx="7.25" cy="16" r="0.75" fill={fill} />
        <circle cx="10" cy="16" r="0.75" fill={fill} />
        <circle cx="12.75" cy="16" r="0.75" fill={fill} />
        <circle cx="15.5" cy="16" r="0.75" fill={fill} />
      </svg>
    </SvgIcon>
  );
};

export default ControlPanelIcon;
